import { render } from "./Home.vue?vue&type=template&id=f7c42d26"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7c42d26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7c42d26', __exports__)) {
    api.reload('f7c42d26', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=f7c42d26", () => {
    api.rerender('f7c42d26', render)
  })

}


export default __exports__